import React, { Component } from 'react';
import Select from 'react-select';

export default class Step extends Component{

  constructor(props) {
    super(props);
    this.handleToogle = this.handleToogle.bind(this);
    this.llenarCombo=this.llenarCombo.bind(this);
    this.isValidated=this.isValidated.bind(this);
    this.state = {
      // disabled = document.getElementById("next-button").disabled = true
      disabled : true,
      value:0,
      selectedOption: null,
      isvalid:false,
      isDisplay:false
     
    };
  }
  isValidated(){
    if(this.state.isvalid){
    this.setState({isvalid:false,isDisplay:false,selectedOption:null});
    return true;
    }
    else{
      this.setState({isDisplay:true});
      return false;
    }
    
  }
  handleToogle() {
   
    this.setState({disabled: !this.state.disabled});
  }
  llenarCombo(items,id){
    if(items!=null){
      if(Array.isArray(items)){
          if(items.length>0){
            //var i=0;
            return items.map((m, index)=>{
                    if(m.valor === this.state.value)
                       {
                        return( 
                            <option value={m.valor} selected>{m.descripcion}</option>
                            );
                       }else{
                        return( 
                            <option value={m.valor}>{m.descripcion}</option>
                            );
                       }
            });
          }
      }
    }
  }
  render(){
      if(this.props.type === 'Combo'){
        return(
                <div className="row">
                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"></div>
                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                        <label>{this.props.label}</label>
                        <br/>
                        {/* <select id={this.props.id} style={{width:'100%'}} onChange={e=> this.onChange(e)} >
                        <option value='0'>Seleccione...</option>
                                    {this.llenarCombo(this.props.opciones,this.props.id)}
                        </select> */}
                        <Select
                          id={this.props.id}
                          value={this.state.selectedOption}
                          onChange={e=> {this.props.onChange(e,this)}}
                          options={this.props.opciones}
                        />
                        <label style={{display:!this.state.isDisplay?'none':'',color:'red'}}>Favor de contestar la pregunta</label>
                    </div>
                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"></div>
                </div>
            )

      }else{
        return(
            <div className="row">
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"></div>
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <label>{this.props.label}</label>
                        <br/>
                    <label className="switch">
                        <input type="checkbox" name={this.props.id} id={this.props.id}/>
                        <span className="slider round" /> 
                    </label>
                </div>
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"></div>
            </div>
        )
      }
  
  }
}


